<template>
  <div>
    <div v-if="user && user.IsMentor">
      <el-col :sm="{ span: 6}" v-bind:class="mobileSelected">
        <el-button round icon="el-icon-plus" @click="navToCreate('manual')">Contact</el-button>
        <br>
        <list v-loading="!contacts" :listData="contactListWithName" @select="handleSelectContact"/>
        <br>
        <export-to-c-s-v-button class="m-50" :data="contacts">Download Contacts</export-to-c-s-v-button>
      </el-col>
      <el-col ref="useCaseCol" :sm="{ span: 17}" :offset="1">
        <router-view :contactId="selectedContactId"/>
      </el-col>
      <el-dialog :visible.sync="createDialog" width="90%">
        <h1>How would you like to add a contact?</h1>
        <br>
        <el-button type="primary" @click="navToCreate('manual')">Manually</el-button>
        <!-- <el-button type="primary">From Mentor Code</el-button> -->
        <!-- <el-button type="primary">From CSV</el-button> -->
      </el-dialog>
    </div>
    <div v-else>
      <empty-contact/>
    </div>
  </div>
</template>

<script>
import List from '@/components/List'
import EmptyContact from '@/components/contacts/EmptyContact'
import ExportToCSVButton from '@/components/contacts/ExportToCSVButton'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      createDialog: false
    }
  },
  computed: {
    ...mapGetters(['contacts', 'user']),
    contactListWithName() {
      if (!this.contacts) return []
      return this.contacts.map(c =>
        Object.assign(c, { Name: c.FirstName + ' ' + c.LastName })
      )
    },
    selectedContactId() {
      return this.$route.params.contactId
    },
    mobileSelected() {
      const isSelected = this.selectedContactId
      return { 'hidden-xs-only': isSelected }
    }
  },
  methods: {
    handleSelectContact(contact) {
      this.$router.push({ path: '/contacts/' + contact.Id })
    },
    navToCreate(createType) {
      this.$router.push({
        name: 'Create Contact',
        params: { type: createType }
      })
    }
  },
  components: {
    List,
    EmptyContact,
    ExportToCSVButton
  }
}
</script>

<style scoped>
.m-50 {
  margin-top: 50px;
}
</style>
